import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
    Pagination,
    ProtoListRequest,
    ProtoResponse,
    SortDirectionFinancing
} from '@lsq-frontend/angular-shared/api-service';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';
import { Report } from './models/report';
import { ReportType } from './models/reports.constants';
import { ReportCenterApiService } from './report-center-api';

@Injectable()
export class GetCompanyReportsService extends ReportCenterApiService<
    GetCompanyReportsRequest,
    GetCompanyReportsResponse
> {
    public requestType = GetCompanyReportsRequest;
    public responseType = GetCompanyReportsResponse;
    public endpointName = 'v1/reports';

    constructor(http: HttpClient, @Inject(SETTINGS) settings: ISettings) {
        super(http, settings);
    }
}

export class GetCompanyReportsRequest extends ProtoListRequest {
    public companyRoleId: number;
    public reportName: string;
    public reportType: ReportType;
    public pagination: Pagination;

    constructor(params?: Partial<GetCompanyReportsRequest>) {
        super();
        this.companyRoleId = params?.companyRoleId || -1;
        this.reportName = params?.reportName || null;
        this.reportType = params?.reportType || ReportType.All;
        this.pagination =
            params?.pagination ||
            new Pagination({
                skip: 0,
                take: 25,
                sortColumn: 'name',
                sortDirection: SortDirectionFinancing.ASCENDING
            });
    }
}

export class GetCompanyReportsResponse extends ProtoResponse {
    public error: Error;
    public rows?: Report[];

    constructor(obj?: Partial<GetCompanyReportsResponse>) {
        super();
        this.ok = true;
        this.error = obj?.error || null;
        this.rows = (obj?.rows || []).map((row) => new Report(row));
        this.totalCount = obj?.totalCount || 0;
    }
}
